// import '@springboardjs/mantine/mantine_module';

// import '../../jamtools/packages/jamtools/core/modules/files/files_module';
import 'springboard/modules/files/files_module';

import './user_context/user_context_module';
import './navigation/navigation_module';


// import './files/files_module';
import './usertour/usertour_module';


import './error_testing/error_testing_module';

import './audio_player/audio_player_module'
import './tags/tags_module';

import './music_sniper/music_sniper_module';
import './audio_trimmer/audio_trimmer_module';

import './ui_entrypoints/ui_entrypoints_module';

// import '../../tauri/springboard-tauri/app/index.ts';

// import './files/files_module_tauri';

// if (typeof window !== 'undefined') {
//     const { Command } = window.__TAURI__.shell;

//     const wsCommand = Command.sidecar('binaries/ws-server');
//     wsCommand.execute();

//     const maestroCommand = Command.sidecar('binaries/maestro-server');
//     maestroCommand.execute();
// }


// import '../styles/tailwind-output.css';
// document.documentElement.classList.add('dark');

// import 'semantic-ui-css/semantic.min.css';


